import { render, staticRenderFns } from "./Search.vue?vue&type=template&id=476fe1d4&scoped=true"
import script from "./Search.vue?vue&type=script&setup=true&lang=js"
export * from "./Search.vue?vue&type=script&setup=true&lang=js"
import style0 from "./Search.vue?vue&type=style&index=0&id=476fe1d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "476fe1d4",
  null
  
)

export default component.exports